/* istanbul ignore file */

import { CommonModule } from '@angular/common';
import { Component, Input, contentChild } from '@angular/core';

import { ParsedTextBlockComponent } from '../parsed-text-block/parsed-text-block.component';

@Component({
  selector: 'joymo-description-block[title]',
  templateUrl: './description-block.component.html',
  styleUrls: ['./description-block.component.scss'],
  imports: [CommonModule, ParsedTextBlockComponent],
  standalone: true,
})
export class DescriptionBlockComponent {
  @Input() title!: string;
  @Input() description?: string;
  @Input() centerTitleOnSmallScreens = false;
  descriptionTpl = contentChild<any>('descriptionTpl');
}
